export function ReportGroupCount({ count }: { count: number }) {
  const total = Number.isFinite(count) ? Math.max(1, Math.floor(count)) : 1
  return <>{total} 个群在推 · 1/{total}</>
}
